export default __webpack_public_path__ + "static/media/classroom-summary.1e8718b9.png";